module.exports = __webpack_public_path__ + "decorateRight-ac4eb3b9420d11b9e43364c878126724.png";